export default class DeserializedCollectorValue {
  constructor(cv) {
    Object.assign(this, cv);
    this.docId = cv.docId === "null" ? undefined : cv.docId;
  }
}
